<template>
    <el-card class="box-card" v-loading="dataLoading">
        <div slot="header" class="clearfix">
            <span>
                <span class="el-icon-data-line"></span> 热度 
                <!-- <span class="color-info">(热度值:<span class="color-danger">{{data && data.totalNumSum || 0}}</span>)</span> -->
                <el-select v-if="data && data.numChart && data.numChart.lineSeriesData" size="mini" v-model="typeName" @change="drawChart">
                    <el-option v-for="(item,index) in data.numChart.lineSeriesData" :key="index" :value="item.name"></el-option>
                </el-select>
            </span>
            <router-link v-if="$utils.have('/hot/statistics/list') && intervalData" class="fr color-theme" :to="`/report/hot/list?rangeStart=${intervalData.startTime} 00:00:00&rangeEnd=${intervalData.endTime} 23:59:59`">
                查看详情<span class="el-icon-right"></span>
            </router-link>
        </div>
        <div class="content">
           <div id="chartContainer" ref="chartContainer"></div>
        </div>
    </el-card>
</template>

<script>
import { Chart } from '@antv/g2';
export default {
    props:{
        intervalData:{
            type: Object,
            default: () => null
        },
        daterange: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            data: null,
            dataLoading: false,
            typeName: ""
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        intervalData(v1,v2){
            if(v1 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/hotData",
                method: "POST",
                data: {
                    timeInterval: this.intervalData.timeInterval || "",
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.typeName = result.numChart.lineSeriesData[0].name;
                        this.$nextTick(() => {
                            this.drawChart();
                        })
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        drawChart(){
            if( this.chart ) this.chart.destroy();
            
            let _data = [];

            this.data.numChart.lineSeriesData.map( item => {
                if(item.name == this.typeName){
                    _data = [...item.value]
                }
            })

            this.chart = new Chart({
                container: 'chartContainer',
                autoFit: true,
                height: 300,
            });
            this.chart.data(_data);

            this.chart.tooltip({
                showTitle: false,
                showMarkers: false,
                showCrosshairs: true,
                itemTpl: '<div><div class="g2-tooltip-title" style="font-size:14px;font-weight:700;">{name}：{value}</div><ul class="g2-tooltip-list">{rank}</ul></div>',
            });
            
            if( _data.length > 7 ){
                this.chart.option('slider', {
                    start: (_data.length - 7) / _data.length,
                    end: 1,
                });
            }
            this.chart
                .line()
                .position('name*value')
                .shape('smooth')
                .tooltip('name*value*rank', (name,value,rank) => {
                    
                    let _rank = ""
                    rank.map(v => {
                        _rank += `<li class="g2-tooltip-list-item"><span class="g2-tooltip-name">${v.name}</span>：<span class="g2-tooltip-value">${v.value}</span></li>`
                    })

                    return {
                        name: name,
                        value: value,
                        rank: _rank
                    };
                });

            this.chart.render();
            
        }
    }
}
</script>

<style lang="scss" scoped>
.content{
    
}
</style>